import { useUserStore } from "@/store";

export default function useUser() {
  const userStore = useUserStore();
  const logout = async (logoutTo?: string) => {
    await userStore.logout();
  };
  return {
    logout,
  };
}
